// extracted by css-extract-rspack-plugin
export default {"col":"col-pBEpDg","list":"list-JsQ2Yl"};